import React from 'react';

const ExportIcon = () => (
    <svg viewBox="0 0 100 100">
        <polygon points="75.219,37.73 73.173,39.928 82.392,48.497 48.076,48.497 48.076,51.497 82.397,51.497 73.173,60.069 75.219,62.267   88.413,50 "></polygon>
        <polygon points="67.931,78.922 10.087,78.922 10.087,21.078 67.931,21.078 67.931,39.858 64.931,39.858 64.931,24.078   13.087,24.078 13.087,75.922 64.931,75.922 64.931,60.145 67.931,60.145 "></polygon>
    </svg>
);


export default ExportIcon;